/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 006255c57733
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";

export type DeleteTransformationGlobals = { cloud_name?: string | undefined };

export const DeleteTransformationGlobals$zodSchema: z.ZodType<
  DeleteTransformationGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type DeleteTransformationRequest = {
  transformation: string;
  invalidate?: boolean | undefined;
};

export const DeleteTransformationRequest$zodSchema: z.ZodType<
  DeleteTransformationRequest
> = z.object({
  invalidate: z.boolean().describe(
    "Invalidate derived resources generated using the deleted transformation from CDN.",
  ).optional(),
  transformation: z.string().describe(
    "The transformation identifier. Can be either a named transformation (e.g., 'small_profile_thumbnail') or a transformation string (e.g., 'w_100,h_150,c_fill,g_auto').\n",
  ),
});

export type DeleteTransformationResponse = MessageResponse | ApiError;

export const DeleteTransformationResponse$zodSchema: z.ZodType<
  DeleteTransformationResponse
> = z.union([
  MessageResponse$zodSchema,
  ApiError$zodSchema,
]);
